
<div>
    <div>
        <v-text-field
            hide-details
            class         = "mt-0 pt-5 mb-3"
            @input        = "onInput"
            v-model       = "sitesearch"
            :disabled     = "!customer"
            :append-icon  = "fullsearch ? 'fas fa-search-plus' : 'fas fa-search'"
            :label        = "fullsearch ? 'Volltextsuche' : 'Fabrik-Nr.'"
            @click:append ="fullsearch=!fullsearch"

            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
        />
    </div>

    <v-container
        class="site-seletable-content pa-0"
    >
        <v-card
            class="dragable-card"
            v-for="(item,index) in selectable"
            :key="index"
            @click="onSite(item)"
            flat
        >
            <div class="v-flex primary--text" style="justify-content: space-between">
                <div>Fabrik-Nr. {{ item.fabricNo }}</div>
                <div>{{ item.customer.name }}</div>
            </div>
            <!--
            <div class="card-subtitle ">{{ item.type.name }}</div>
            -->
            <div class="card-subtitle">{{ item.street }}, {{ item.zip }} {{ item.city }}</div>
        </v-card>
    </v-container>
</div>
